// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.direct-interpreter__availability[data-v-3b37e281] {\n  overflow: auto;\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
